import { object as R, dayjs as w } from "@myparcel-frontend/utils";
import { reactive as F, readonly as b, watch as E, unref as V, ref as T, onUnmounted as C, nextTick as k, computed as D, onMounted as P } from "vue";
import { watchPausable as U } from "@vueuse/core";
const S = F({});
function Y() {
  const e = ([s, l]) => {
    const u = w(), a = w(s), n = w(l);
    return l ? s ? u.isBetween(a, n) : u.isBefore(n) : u.isAfter(a);
  }, c = (s) => {
    const l = {}, u = R.flatten(s);
    return Object.entries(u).forEach(([a, n]) => {
      const d = a;
      if (!Array.isArray(n)) {
        l[d] = n;
        return;
      }
      const [m, t] = n;
      l[d] = e([m, t]);
    }), l;
  }, r = () => {
    const s = {}, l = [];
    for (let u = 0; u < localStorage.length; u++) {
      const a = localStorage.key(u);
      a && l.push(a);
    }
    return l.filter((u) => u.startsWith("features.")).forEach((u) => {
      const a = u.replace("features.", ""), n = localStorage.getItem(u) === "true";
      s[a] = n;
    }), s;
  }, i = (s) => {
    const l = c(s), u = r();
    Object.keys(S).forEach((a) => delete S[a]), Object.assign(S, {
      ...l,
      ...u
    });
  }, o = (s) => S[s] ?? !1;
  return {
    features: b(S),
    loadFeatures: i,
    isFeatureActive: o
  };
}
const z = (e, c, r, i = "watch") => {
  i === "watch" && E(
    e,
    async () => {
      await o();
    },
    { deep: !0 }
  );
  const o = async () => {
    const u = r.currentRoute.value.query, a = V(e), n = {};
    Object.keys(a).forEach((d) => {
      const m = c.value.find((t) => t.name === d)?.type;
      if (m === "checkbox") {
        const t = a[d];
        n[d] = t.length ? t.join(";") : void 0;
        return;
      }
      if (m === "radio") {
        const t = a[d];
        n[d] = t ? String(t) : void 0;
        return;
      }
      if (m === "number") {
        const t = a[d];
        n[d] = t ? String(t) : void 0;
        return;
      }
      if (m === "dateRange") {
        const t = a[d], f = t?.from ? t.from.toISOString().split("T")[0] : "", h = t?.to ? t.to.toISOString().split("T")[0] : "";
        n[d] = f.length || h.length ? `${f};${h}` : void 0;
        return;
      }
    }), await r.replace({
      query: {
        ...u,
        ...n
      }
    });
  }, s = () => {
    const l = r.currentRoute.value.query;
    if (c.value.filter((n) => l[n.name] !== void 0).length === 0)
      return;
    const a = {};
    c.value.forEach((n) => {
      const d = l[n.name], m = {
        checkbox: [],
        number: null,
        radio: null,
        dateRange: { from: null, to: null }
      };
      if (d === void 0) {
        a[n.name] = m[n.type];
        return;
      }
      if (n.type === "checkbox") {
        const f = d.split(";").filter(
          (h) => n.options.find((p) => p.value === h)
        );
        a[n.name] = f;
        return;
      }
      if (n.type === "number") {
        const t = Number(d);
        a[n.name] = Number.isNaN(t) ? null : t;
        return;
      }
      if (n.type === "radio") {
        const t = d, f = Number(t), h = n.options.find(
          (p) => p.value === t || p.value === f
        );
        a[n.name] = h?.value ?? null;
      }
      if (n.type === "dateRange") {
        const t = d ? d.split(";") : [], f = new Date(t[0]), h = new Date(t[1]), p = (O) => !isNaN(O.getTime());
        a[n.name] = {
          from: p(f) ? f : null,
          to: p(h) ? h : null
        };
      }
    }), e.value = a;
  };
  return s(), {
    setFiltersToUrl: o,
    getFiltersFromUrl: s
  };
};
var y = { Canada: "CA", UnitedStatesOfAmerica: "US" }, v = { Registered: 0, HandedToCarrier: 3, Sorting: 4, Distribution: 5, Delivered: 7 }, B = { Info: "info" }, L = { Toaster: "toaster" }, A = { Asc: "ASC", Desc: "DESC" };
const N = T([]), M = T(0), K = 6e3;
function J() {
  const e = ({
    id: i,
    variant: o = B.Info,
    canClose: s,
    withShadow: l,
    body: u,
    title: a,
    timeout: n = K,
    location: d = L.Toaster
  }) => {
    let m = i;
    m || (M.value++, m = M.value.toString()), N.value.unshift({
      id: m,
      body: u,
      variant: o,
      title: a,
      timeout: n,
      location: d,
      canClose: s,
      withShadow: l
    }), n && setTimeout(() => {
      c(m);
    }, n);
  }, c = (i) => {
    N.value = N.value.filter((o) => o.id !== i);
  }, r = () => {
    N.value = [];
  };
  return {
    notifications: b(N),
    addNotification: e,
    removeNotification: c,
    clearNotifications: r
  };
}
const I = T(!1);
function q() {
  return {
    pageTitleStatus: I,
    setPageTitle: (i) => {
      document.title = i, I.value = !0;
    },
    resetPageTitle: () => {
      I.value = !1;
    }
  };
}
function G() {
  const e = T(-1), c = (s) => {
    e.value = s;
  }, r = () => {
    c(-1);
  }, i = (s) => {
    const l = s.length - 1;
    if (e.value >= l)
      return;
    const a = e.value + 1;
    c(a);
  }, o = () => {
    if (e.value < 0)
      return;
    const l = e.value - 1;
    c(l);
  };
  return {
    pointer: b(e),
    updatePointer: c,
    resetPointer: r,
    incrementPointer: i,
    decrementPointer: o
  };
}
const _ = (e, c, r, i) => {
  const o = T([]), s = (a) => {
    const n = JSON.parse(JSON.stringify(e));
    r[a].forEach((m) => {
      const t = m.split(".");
      let f = n, h = c;
      t.forEach((p, O) => {
        O === t.length - 1 ? f[p] = h[p] : (f = f[p], h = h[p]);
      });
    }), i ? i(n, !1) : Object.assign(e, n);
  }, l = () => {
    Object.keys(r).forEach((a) => {
      const n = U(
        () => R.get(e, a),
        async () => {
          o.value.forEach((d) => d.pause()), s(a), await k(), o.value.forEach((d) => d.resume());
        }
      );
      o.value.push(n);
    });
  }, u = () => {
    o.value.forEach((a) => a.stop()), o.value = [];
  };
  return C(() => {
    u();
  }), {
    watchers: o,
    initResetTree: l,
    stopResetTree: u
  };
}, g = F({});
function X(e, c = {}, r = { keepOnUnmount: !1 }) {
  g[e] || (g[e] = {}), c && (g[e] = F(c));
  const i = {
    [A.Asc]: "ascending",
    [A.Desc]: "descending"
  }, o = D(() => l()), s = D(() => u()), l = () => Object.keys(g[e]).find((t) => g[e][t]) ?? void 0, u = () => Object.values(g[e]).find((t) => t) ?? void 0, a = (t) => t === l() ? u() : void 0, n = (t) => {
    const f = g[e][t];
    return f ? i[f] : "none";
  }, d = (t) => {
    for (const f in g[e])
      f !== t && (g[e][f] = null);
  }, m = (t) => {
    d(t), g[e][t] === A.Desc ? g[e][t] = null : g[e][t] === A.Asc ? g[e][t] = A.Desc : g[e][t] = A.Asc;
  };
  return r.keepOnUnmount || C(() => {
    g[e] && delete g[e];
  }), {
    // Only exported to test the unmount clean-up in the test file.
    allSorters: b(g),
    sorters: b(g[e]),
    sort: o,
    order: s,
    sortByColumn: m,
    getOrder: a,
    getOrderBy: u,
    getOrderAriaLabel: n
  };
}
function Z() {
  const e = T([]), c = (o) => {
    e.value.push(o);
  }, r = (o) => {
    e.value = e.value.filter((s) => s !== o);
  }, i = new ResizeObserver((o) => {
    !o[0] || !e.value.length || e.value.forEach((l) => l());
  });
  return P(() => {
    i.observe(document.body);
  }), C(() => {
    i.disconnect();
  }), {
    watchResize: c,
    unwatchResize: r
  };
}
const j = [
  { name: "Alberta", code: "AB" },
  { name: "British Columbia", code: "BC" },
  { name: "Manitoba", code: "MB" },
  { name: "New Brunswick", code: "NB" },
  { name: "Newfoundland and Labrador", code: "NL" },
  { name: "Nova Scotia", code: "NS" },
  { name: "Northwest Territories", code: "NT" },
  { name: "Nunavut", code: "NU" },
  { name: "Ontario", code: "ON" },
  { name: "Prince Edward Island", code: "PE" },
  { name: "Saskatchewan", code: "SK" },
  { name: "Quebec", code: "QC" },
  { name: "Yukon", code: "YT" }
], x = [
  { name: "Alabama", code: "AL" },
  { name: "Alaska", code: "AK" },
  { name: "Arizona", code: "AZ" },
  { name: "Arkansas", code: "AR" },
  { name: "California", code: "CA" },
  { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "Florida", code: "FL" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Indiana", code: "IN" },
  { name: "Iowa", code: "IA" },
  { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" },
  { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" },
  { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" },
  { name: "Mississippi", code: "MS" },
  { name: "Missouri", code: "MO" },
  { name: "Montana", code: "MT" },
  { name: "Nebraska", code: "NE" },
  { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" },
  { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Ohio", code: "OH" },
  { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" },
  { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Vermont", code: "VT" },
  { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" },
  { name: "Washington DC", code: "DC" },
  { name: "West Virginia", code: "WV" },
  { name: "Wisconsin", code: "WI" },
  { name: "Wyoming", code: "WY" }
], $ = () => ({
  getStates: (r) => {
    switch (r) {
      case y.UnitedStatesOfAmerica:
        return x;
      case y.Canada:
        return j;
      default:
        return [];
    }
  },
  hasStates: (r) => {
    switch (r) {
      case y.UnitedStatesOfAmerica:
      case y.Canada:
        return !0;
      default:
        return !1;
    }
  }
});
function ee() {
  const e = T(!1), c = (s) => {
    e.value = s;
  }, r = () => {
    c(!e.value);
  }, i = () => {
    c(!0);
  }, o = () => {
    c(!1);
  };
  return {
    toggle: b(e),
    updateToggle: c,
    toggleToggle: r,
    toggleToTrue: i,
    toggleToFalse: o
  };
}
function te() {
  const e = (r, i) => {
    const o = r.status.current, s = c(r);
    return [...i ? [
      {
        type: "header",
        description: i.registered,
        disabled: o < v.Registered,
        status: v.Registered
      },
      {
        type: "header",
        description: i.handedToCarrier,
        disabled: o < v.HandedToCarrier,
        status: v.HandedToCarrier
      },
      {
        type: "header",
        description: i.sorting,
        disabled: o < v.Sorting,
        status: v.Sorting
      },
      {
        type: "header",
        description: i.distribution,
        disabled: o < v.Distribution,
        status: v.Distribution
      },
      {
        type: "header",
        description: i.delivered,
        disabled: o < v.Delivered,
        status: v.Delivered
      }
    ] : [], ...s].sort((a, n) => {
      const d = a.status, m = n.type === "header" && n.status === v.Delivered ? 1 / 0 : n.status;
      return d - m;
    });
  }, c = (r) => {
    const i = r.status.current, o = r.history.map((s) => ({
      type: "item",
      date: s.time,
      description: s.description,
      disabled: !1,
      status: s.status
    }));
    return o.push({
      type: "item",
      date: r.time,
      description: r.description,
      disabled: !1,
      status: i
    }), o;
  };
  return { getFormattedTrackAndTrace: e, getTrackAndTraceItems: c };
}
export {
  Y as useFeatures,
  z as useFilterQuery,
  J as useNotification,
  q as usePageTitle,
  G as usePointer,
  _ as useResetTree,
  Z as useResize,
  X as useSortControl,
  $ as useStates,
  ee as useToggle,
  te as useTrackAndTrace
};
